/**
 * Materialidade da divergência de auditoria para SINALIZAR ao cliente.
 *
 * - Relatório e histórico: usam a MESMA tolerância da auditoria — divergência
 *   ≥ 2% do valor da fatura (`isReportOvercharge`).
 * - Dashboard: além dos 2%, um piso de R$ MIN_OVERCHARGE_BRL para o agregado da
 *   carteira não somar valores irrelevantes (`isDashboardOvercharge`).
 *
 * Limiar tunável (a validar com dados reais — Fase E).
 */
export const MIN_OVERCHARGE_BRL = 50;
export const OVERCHARGE_PCT = 0.02; // 2% — mesma tolerância da auditoria

export const isReportOvercharge = (
  overcharge: number,
  invoiceValue: number
): boolean => invoiceValue > 0 && overcharge / invoiceValue >= OVERCHARGE_PCT;

export const isDashboardOvercharge = (
  overcharge: number,
  invoiceValue: number
): boolean =>
  isReportOvercharge(overcharge, invoiceValue) &&
  overcharge >= MIN_OVERCHARGE_BRL;
